import { createSlice } from "@reduxjs/toolkit";
import { companyProfile } from "./thunk";

const initialState = {
  isLoading: false,
  geolocation: {
    latitude: null,
    longitude: null,
    source: null, // "auto" | "manual"
    label: null, // optional (e.g. "Nairobi CBD")
  },
  locationData: {
    placeId: "",
    formattedAddress: "",
    latitude: null,
    longitude: null,
    county: "",
    city: "",
    postalCode: "",
    country: "",
  },
  // companyProfile: {},
};

export const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers: {
    setGeolocation: (state, action) => {
      state.geolocation.latitude = action.payload.latitude;
      state.geolocation.longitude = action.payload.longitude;
      state.geolocation.source = action.payload.source ?? null;
      state.geolocation.label = action.payload.label ?? null;
    },
    setLocation: (state, action) => {
      state.locationData.placeId = action.payload?.placeId;
      state.locationData.formattedAddress = action.payload?.formattedAddress;
      state.locationData.county = action.payload?.county;
      state.locationData.city = action.payload?.city;
      state.locationData.postalCode = action.payload?.postalCode;
      state.locationData.country = action.payload?.country;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch cart
      .addCase(companyProfile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(companyProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.companyProfile = action.payload?.companyProfile ?? {};
      })
      .addCase(companyProfile.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { setGeolocation, setLocation } = systemSlice.actions;

export default systemSlice.reducer;
